import * as forge from 'node-forge';

const rsaEncrypt = (input: string, publicKey: string) => {
    const rsa = forge.pki.publicKeyFromPem(publicKey);
    const en = rsa.encrypt(forge.util.encodeUtf8(input));
    const en64 = forge.util.encode64(en);
    return en64;
};

export { rsaEncrypt };
